// extracted by mini-css-extract-plugin
module.exports = {"btnaddfocus":"index_btnaddfocus_8oDa2","header":"index_header_dfADW"};